// A leading numbering such as "3.", "3.1.5.1." or "3.2.2.1" (the final dot is
// optional) followed by the name.
const NUMBERED_TITLE = /^(\d+(?:\.\d+)*\.?)\s+(.+)$/;

/** Tabs and double spaces typed into a title, folded to single spaces. */
export const collapseWhitespace = (title: string): string =>
  title.replace(/\s+/g, " ").trim();

/**
 * Category titles are typed by hand: "3.1.5.1. 2025 metai Sankcijų tikrinimas",
 * "4.2.2.<tab>2024 metai", "3.2.2.1 Kasko". The numbering is shown muted and
 * apart from the name, and stray tabs and double spaces are dropped. The
 * wording itself is kept exactly as stored.
 */
export function splitCategoryTitle(title: string): {
  number: string;
  name: string;
} {
  const collapsed = collapseWhitespace(title);
  const match = NUMBERED_TITLE.exec(collapsed);
  // "2025 metai" starts with digits but is a name, not numbering: a number has a dot.
  if (!match || !match[1].includes(".")) return { number: "", name: collapsed };
  return { number: match[1].replace(/\.$/, ""), name: match[2] };
}
